import ConfirmationBlob from 'components/common/general/ConfirmationBlob';
import { Alert } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ConfirmationBlobStyled = styled(ConfirmationBlob)`
  margin-top: 5rem;
`;

export const AlertStyled = styled(Alert)`
  margin: 3rem 0 0;
`;

export const BypassWarningMessageStyled = styled.p`
  margin: 0;
  text-align: left;
`;
